import { Component } from '@angular/core';

@Component({
	templateUrl: './page-forbidden.component.html',
	selector: 'page-forbidden'
})
export class PageForbidden {}
